import PromoCodeModal from './PromoCodeModal';

export default {
  PromoCodeModal,
};
